// used to manage raw data objects through http including update channel and api version information in the wrapper
export const rawDataKey = 'raw-data';
export const RAW_DATA = { [rawDataKey]: 'true' };
